// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__108Su","title":"AfterFrontImage_title__3iwaB"};